class LocalStorage {
	static get(key) {
		const item = localStorage.getItem(key);
		return item ? JSON.parse(item) : undefined;
	}

	static set(key, item) {
		localStorage.setItem(key, JSON.stringify(item));
	}

	static remove(key) {
		localStorage.removeItem(key);
	}
}

export default LocalStorage;
